
<template>



    <div v-if="images && images.length" class="single-image">
        <span class="has-bg-image bg-full"
              role="img"
              :style="{'background-image' : 'url(' + images[0].Path +')'}"></span>

        <button class="open" v-on:click="showImages" v-if="images.length > 1">Open</button>

    </div>

    <vue-easy-lightbox escDisabled
                       moveDisabled
                       :visible="visible"
                       :imgs="imgs"
                       :index="index"
                       @hide="handleHide"></vue-easy-lightbox>


</template>



<script>
    import VueEasyLightbox from 'vue-easy-lightbox'

    export default {
        name: 'SingleImage',
        props: {
            images: Object,
        },
        data() {
            return {
                imgs: '', // Img Url , string or Array of string
                visible: false,
                index: 0 // default: 0
            }
        },
        components: {
            VueEasyLightbox
        },
        methods: {

            showImages() {
                this.imgs = this.images.map(x => x.Path);
             
                this.index = 1 // index of imgList
                this.show()
            },
            show() {
                this.visible = true
            },
            handleHide() {
                this.visible = false
            }
        }
    }
</script>

<style>
    .single-image {
        height: 100%;
        width: 100%;
        position: relative;
        z-index: 1;
    }

        .single-image .open {
            position: absolute;
            bottom: 0;
            right: 0;
            z-index: 5;
            text-indent: -9999px;
            border: none;
            height: 34px;
            width: 34px;
            background-color: rgba(26,26,26,0.7);
            background-image: url(/Assets/img/booking/single-image-mg.svg);
            background-position: center center;
            background-size: 13px 13px;
            background-repeat: no-repeat;
        }
</style>